import type { DependsOn } from '@common/formEngine/dependsOn';
import type { Subsection } from '@common/formEngine/formEngine.types';
import type { DeepPickPath } from '@common/utils/deepPickUtils';
import type { NullablePrimitives } from '@common/utils/utilityTypes';

export type ExternalReferralData = {
    doorverwijzing: NullablePrimitives<{
        aanvraag_voor: string;
        afdeling: string;
        bericht_aan_behandelaar: string;
        reden: string;
        specialist_naam: string;
        zorginstelling: string;
    }>;
};

export type ExternalReferralContentKeys = 'bijgevoegde_informatie';

export function createExternalReferralSubsections<Data extends Record<string, unknown> & ExternalReferralData>(
    include?: DependsOn<Data, boolean>
): Subsection<Data, ExternalReferralContentKeys>[] {
    return [
        {
            fields: [
                {
                    isRequired: true,
                    key: 'doorverwijzing.zorginstelling' as DeepPickPath<Data>,
                    label: 'Zorginstelling',
                    type: 'textInput',
                },
                {
                    key: 'doorverwijzing.afdeling' as DeepPickPath<Data>,
                    label: 'Afdeling',
                    type: 'textInput',
                },
                {
                    key: 'doorverwijzing.specialist_naam' as DeepPickPath<Data>,
                    label: 'Specialist, naam',
                    type: 'textInput',
                },
            ],
            include,
            title: 'Aan',
        },
        {
            fields: [
                {
                    isRequired: true,
                    key: 'doorverwijzing.aanvraag_voor' as DeepPickPath<Data>,
                    label: 'Aanvraag voor (onderwerp)',
                    type: 'textInput',
                },
                {
                    isRequired: true,
                    key: 'doorverwijzing.bericht_aan_behandelaar' as DeepPickPath<Data>,
                    label: 'Bericht aan behandelaar',
                    type: 'textArea',
                },
                {
                    isRequired: true,
                    key: 'doorverwijzing.reden' as DeepPickPath<Data>,
                    label: 'Reden doorverwijzing',
                    type: 'textArea',
                },
            ],
            include,
            title: 'Aanvraag',
        },
        {
            fields: [
                {
                    key: 'bijgevoegde_informatie',
                    type: 'content',
                },
            ],
            include,
            title: 'Patiëntinformatie',
        },
    ];
}
